import { render, staticRenderFns } from "./FeeSchedules.vue?vue&type=template&id=175567a2&scoped=true"
import script from "./FeeSchedules.vue?vue&type=script&lang=ts"
export * from "./FeeSchedules.vue?vue&type=script&lang=ts"
import style0 from "./FeeSchedules.vue?vue&type=style&index=0&id=175567a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175567a2",
  null
  
)

export default component.exports